import React from 'react'
import { useTranslation } from 'react-i18next'

import Modal from '../../common/components/Modal/Modal'
import svgImage from './PremiumTemplatesModalImage.svg'

const PremiumTemplatesModal = ({ onClose, history }) => {
    const { t } = useTranslation()
    return (
        <Modal onClose={() => onClose()} closeOnOverlayClick={false} isShowCloseIcon={true}>
            <div className="premium-templates-modal">
                <div className="premium-templates-modal__header">
                    {t('Upgrade your plan \nto unlock premium templates')}
                </div>
                <div className="premium-templates-modal__img">
                    <img src={svgImage} alt="" />
                </div>
                <div className="premium-templates-modal__descriptions">
                    {t('Premium templates are available for plans \nstarting from ')}
                    <span>Education.Beginner</span>
                </div>
                <div className="premium-templates-modal__buttons">
                    <button
                        className="button"
                        data-size="md"
                        data-variant="secondary"
                        data-test="use-this-layout"
                        onClick={onClose}
                    >
                        {t('Next time')}
                    </button>
                    <button
                        className="button"
                        data-size="md"
                        data-variant="primary"
                        data-test="use-this-layout"
                        onClick={() => history.push('/account/billing-and-payments?tab=subscription')}
                    >
                        {t('Upgrade')}
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default PremiumTemplatesModal
